<template>
  <div class="caseView content-part">
    <div class="banner">
      <img :src="currentLg.banner" alt="" />
    </div>
    <div class="main">
      <div class="main-content">
        <div class="case-veiw-contain">
          <div class="left">
            <div class="content" v-show="locale == 'CN'" v-html="content"></div>
            <div
              class="content-en"
              v-show="locale == 'EN'"
              v-html="contentEn"
            ></div>
            <div class="page">
              <div
                class="page-left"
                @click="link(preContent.id, preContent.index)"
              >
                {{ currentLg.pre }}
                {{
                  locale == "CN"
                    ? preContent.title || "无"
                    : preContent.titleEn || "None"
                }}
              </div>
              <div
                class="page-right"
                @click="link(nextContent.id, nextContent.index)"
              >
                {{ currentLg.next }}
                {{
                  locale == "CN"
                    ? nextContent.title || "无"
                    : nextContent.titleEn || "None"
                }}
              </div>
            </div>
          </div>
          <div class="right">
            <p class="title">{{ currentLg.relation }}</p>
            <swiper :options="mySwiperOption">
              <swiper-slide v-for="i in relationList" :key="i.id">
                <div class="text">
                  <p>
                    <span>{{ locale == "CN" ? i.title : i.titleEn }}</span>
                  </p>
                  <img :src="i.imgUrl" alt="" />
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import language from "./../language/case/index";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  data() {
    return {
      id: "",
      content:
        '<div id="xn_c_casev_1_warp" class="xn_c_casev_1_warp">\n<div class="xn_c_casev_1_title" style="text-align: center;"><span style="font-size: 30px;">大梅沙万科总部</span></div>\n</div>\n<div id="xn_c_casev_2_warp" class="xn_c_casev_2_warp">\n<p>&nbsp;</p>\n<p><img src="http://192.168.0.126:9999/jmjn-portal/2023/08/16/6da27bf6-14c5-41b8-b82c-466b168eb6c2.jpg" /></p>\n<p>&nbsp;</p>\n<p><img src="http://resource.jmjnsz.com/jmjn-portal/2023/08/09/3200f693-fae6-4616-aff3-ac73124d8591.png" /></p>\n<p>&nbsp;</p>\n<p>该项目总用地面积1.92万平方米，总建筑面积16.7万平方米。超级总部基地是深圳市未来城市发展的核心区域，该区域将进一步聚集&ldquo;世界500强&rdquo;和行业顶尖企业。总部大厦落地深圳湾，既是万科作为&ldquo;世界500强&rdquo;企业业务发展的需要，也是&ldquo;城乡建设与生活服务商&rdquo;万科与特区共同生长的需要。</p>\n<p>&nbsp;</p>\n<span id="xn_c_casev_2_Text4"></span>\n<p><img src="http://resource.jmjnsz.com/jmjn-portal/2023/08/09/9f0058c6-9de3-4732-85f0-87eca3b9f252.png" /></p>\n<p>&nbsp;</p>\n<p>节能和调适服务</p>\n<p>&nbsp;</p>\n<p style="text-align: left;"><img src="http://resource.jmjnsz.com/jmjn-portal/2023/08/09/c363c323-37ce-495a-934b-c994e8e03092.png" /></p>\n<p>&nbsp;</p>\n<p>年节能效益 427万 kWh</p>\n<p>累计节能 &nbsp;2061万 kWh</p>\n<p>&nbsp;</p>\n</div>',
      contentEn:
        '<div id="xn_c_casev_1_warp" class="xn_c_casev_1_warp">\n<div class="xn_c_casev_1_title">\n<p style="text-align: center;"><span style="font-size: 30px;"><strong>China Resources Tower</strong></span></p>\n<p style="text-align: center;">&nbsp;</p>\n</div>\n</div>\n<div id="xn_c_casev_2_warp" class="xn_c_casev_2_warp">\n<p><img style="display: block; margin-left: auto; margin-right: auto;" title="华润总部大厦 机电系统调适" src="https://0.rc.xiniu.com/g2/M00/91/19/CgAGe1sU8I-AGfu1AAS3tcSXfik094.jpg" alt="华润总部大厦 机电系统调适" data-original="https://0.rc.xiniu.com/g2/M00/91/19/CgAGe1sU8I-AGfu1AAS3tcSXfik094.jpg" /></p>\n<p>&nbsp;</p>\n<p><img src="http://resource.jmjnsz.com/jmjn-portal/2023/08/16/593f0b98-75ef-421f-9425-752f46df4be3.png" /></p>\n<p>&nbsp;</p>\n<p>The China Resources Tower spans 67,000 square meters and has a total building area of 270,000 square meters. It stands at a height of 392.5 meters and has 66 floors above ground and 5 floors underground.</p>\n<p>&nbsp;</p>\n<p><img src="http://resource.jmjnsz.com/jmjn-portal/2023/08/16/9a5efb12-8805-49a2-87f4-b1518ace8cd6.png" /></p>\n<p>&nbsp;</p>\n<ul>\n<li>VAV model floor, ice storage cold station system, air conditioning system: commissioning</li>\n<li>The whole process of commissioningconsultancy services</li>\n</ul>\n<p><strong>&nbsp;</strong></p>\n<p><img src="http://resource.jmjnsz.com/jmjn-portal/2023/08/16/58fc42ca-1ace-4fb0-a653-1820cc1dca91.png" /></p>\n<p>&nbsp;</p>\n<ul>\n<li>Energy saving: 3 million kWh/y</li>\n<li>20 years full life cycle asset appreciation: hundred million</li>\n<li>Enhancement of commercial experience, noise reduction, enhancement of comfort, and reduction of the risk of tenants\' complaints affecting rent levels</li>\n<li>Building energy problem investigation, found to solve the problem of adaptation of 5 categories totaling 20 items</li>\n<li>Avoided economic losses worth over 30 million CNY</li>\n</ul>\n<p>&nbsp;</p>\n</div>',
      type: "",
      relationList: [
        {
          createDate: 1691396256000,
          desc: "<p>年节电超1000万+kWh，20年超2亿kWh；</p>",
          descEn: "<p>Over 10 million kWh annual saving of electricity</p>",
          id: 26,
          imgUrl:
            "http://resource.jmjnsz.com/jmjn-portal/2023/08/07/d45a3181-604a-4244-a7ee-4d520794562e.png",
          title: "广州太古汇",
          titleEn: "TaiKoo11 Hui Guangzhou ",
          type: 1,
          updateDate: 1691566189000,
        },
        {
          createDate: 1691396256000,
          desc: "<p>年节电超1000万+kWh，20年超2亿kWh；</p>",
          descEn: "<p>Over 10 million kWh annual saving of electricity</p>",
          id: 263,
          imgUrl:
            "http://resource.jmjnsz.com/jmjn-portal/2023/08/07/d45a3181-604a-4244-a7ee-4d520794562e.png",
          title: "广州太古汇1",
          titleEn: "TaiKoo222 Hui Guangzhou ",
          type: 1,
          updateDate: 1691566189000,
        },
        {
          createDate: 1691396256000,
          desc: "<p>年节电超1000万+kWh，20年超2亿kWh；</p>",
          descEn: "<p>Over 10 million kWh annual saving of electricity</p>",
          id: 264,
          imgUrl:
            "http://resource.jmjnsz.com/jmjn-portal/2023/08/07/d45a3181-604a-4244-a7ee-4d520794562e.png",
          title: "广州太古汇2",
          titleEn: "TaiKoo44 Hui Guangzhou ",
          type: 1,
          updateDate: 1691566189000,
        },
        {
          createDate: 1691396256000,
          desc: "<p>年节电超1000万+kWh，20年超2亿kWh；</p>",
          descEn: "<p>Over 10 million kWh annual saving of electricity</p>",
          id: 268,
          imgUrl:
            "http://resource.jmjnsz.com/jmjn-portal/2023/08/07/d45a3181-604a-4244-a7ee-4d520794562e.png",
          title: "广州太古汇26",
          titleEn: "TaiKoo44 Hui Guangzhou ",
          type: 1,
          updateDate: 1691566189000,
        },
      ],
      mySwiperOption: {
        slidesPerView: "auto",
        spaceBetween: 10,
        //自动播放
        autoplay: {
          delay: 50000,
          disableOnInteraction: false,
        },
      },
      preContent: {
        id: 0,
        index: 0,
        title: "",
        titleEn: "",
      },
      nextContent: {
        id: 0,
        index: 0,
        title: "",
        titleEn: "",
      },
    };
  },
  mounted() {
    if (this.$route.query.id && this.$route.query.type) {
      this.id = this.$route.query.id;
      this.type = this.$route.query.type;
      this.getDetail();
      this.getList();
    } else {
      this.$router.push("/index_m/case_m");
    }
  },

  components: {
    // 注册子组件
    swiper,
    swiperSlide,
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    currentLg() {
      return language[this.locale];
    },
  },
  watch: {
    $route(to, from) {
      const { id, type } = to.query;
      this.id = id;
      this.type = type;
      this.getDetail();
      this.getList();
    },
  },
  methods: {
    getDetail() {
      this.$http
        .get("/api/portal/project/query", {
          params: {
            id: this.id,
          },
        })
        .then((res) => {
          // console.log(res)
          this.content = res.data && res.data.content;
          this.contentEn = res.data && res.data.contentEn;
        });
    },
    getList() {
      this.$http
        .get("/api/portal/project/queryPage", {
          params: {
            type: this.type,
            pageNo: 1,
            pageSize: 10,
          },
        })
        .then((res) => {
          const { items = [] } = res.data;
          this.relationList = items
            .filter((i) => i.id != this.id)
            .filter((item, index) => index <= 3);
          const currentIdx = +this.$route.query.index;
          this.preContent = items.find((i, idx) => idx == currentIdx - 1) || {};
          this.nextContent =
            items.find((i, idx) => idx == currentIdx + 1) || {};
          this.preContent.index = currentIdx - 1;
          this.nextContent.index = currentIdx + 1;
          console.log(this.preContent, this.nextContent);
        });
    },
    // 上一篇下一篇
    link(id = "", index) {
      if (id) {
        this.$router.push({
          path: "/index_m/caseView_m",
          query: { id, type: this.type, index },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.caseView {
  .banner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    width: 100vw;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .main {
    .main-content {
      width: auto;
      .case-veiw-contain {
        .left {
          padding: 4vh;

          .page {
            border-top: 1px solid #eaeaea;
            padding-top: 8vh;
            overflow: hidden;
            display: flex;
            div {
              flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #4e4e4e;
              font-size: 4vw;
              display: block;
            }
          }
        }

        .right {
          box-sizing: border-box;
          border-left: 1px dotted #d2d2d2;
          background: rgba(0, 0, 0, 0.1);
          padding: 3vh 0;
          .title {
            font-size: 5vw;
            font-family: SourceHanSansSC-Bold, SourceHanSansSC;
            font-weight: bold;
            color: #262626;
            line-height: 6vh;
            padding: 0 4vw 4vw;
          }
          .text {
            border-radius: 4vh;
            position: relative;
            p {
              position: absolute;
              bottom: 1vw;
              background-color: rgba(0, 0, 0, 0.4);
              color: #fff;
              border-bottom-left-radius: 1vh;
              border-bottom-right-radius: 1vh;
              width: 100%;
              height: 3vh;
              line-height: 3vh;
              span {
                padding: 0 2vw;
                font-size: 4vw;
                font-family: Source Han Sans SC;
                font-weight: 400;
                color: #ffffff;
                display: block;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              }
            }
            img {
              width: 100%;
              border-radius: 1vh;
              height: 100%;
            }
          }
        }
      }
    }
  }
  /deep/.content {
    > p {
      img {
        width: 80vw;
      }
    }
    > p:nth-child(5) > img {
      width: 25vw;
    }
    > p:nth-child(9) > img {
      width: 25vw;
    }
    > p:nth-child(13) > img {
      width: 25vw;
    }
    #xn_c_casev_2_warp {
      > p {
        img {
          width: 80vw;
        }
      }
      p:nth-child(4) > img {
        width: 25vw;
      }
      p:nth-child(9) > img {
        width: 25vw;
      }
      p:nth-child(8) > img {
        width: 25vw;
      }
      p:nth-child(12) > img {
        width: 25vw;
      }
      p:nth-child(13) > img {
        width: 25vw;
      }
    }
  }
}
/deep/.content-en {
  > p {
    img {
      width: 80vw;
    }
  }
  > p:nth-child(5) > img {
    width: 50vw;
  }
  > p:nth-child(9) > img {
    width: 50vw;
  }
  > p:nth-child(13) > img {
    width: 50vw;
  }
  #xn_c_casev_2_warp {
    > p {
      img {
        width: 80vw;
      }
    }
    p:nth-child(3) > img {
      width: 50vw;
    }
    p:nth-child(7) > img {
      width: 50vw;
    }
    p:nth-child(11) > img {
      width: 50vw;
    }
  }
}

.swiper-slide {
  width: 20vh;
}
</style>



// WEBPACK FOOTER //
// src/view/caseView_m.vue